<app-modal>
  <div modal-header>
    <span  i18n="Modal Titel for Lost Password Dialog@@register.modal.title">Lost Password</span>
  </div>
  <div modal-body>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group text-center">
        <label i18n="Ask if already registed@@register.modal.label.alreadyRegistered">Lost your password? Enter your email to send reset instructions!</label>
      </div>
      <div class="form-group form-label-group">
        <input type="text" id="inputEmail" class="form-control" formControlName="email" required/>
        <label for="inputEmail" i18n="Input Label@@lostPassword.form.email.label">Email address</label>
        <div *ngIf="form.controls.email.invalid && (form.controls.email.dirty || form.controls.email.touched)" class="invalid-tooltip">
          <div *ngIf="form.controls.email.errors.required" i18n="Error message when no email is provided@@lostPassword.form.errors.email.required">Email is required.</div>
          <div *ngIf="form.controls.email.errors.email" i18n="Error message when email is no valid address@@lostPassword.form.errors.email.invalid">Email needs to be a valid address.</div>
        </div>
      </div>
      <div class="text-center">
        <div class="btn-primary-container">
          <button type="submit" class="btn btn-primary">
            <span i18n="Register Form Submit button@@lostPassword.form.submit.label">Request Reset</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</app-modal>